import colors from "@constants/colors"
import React from "react"

interface IconProps {
  strokeColor?: string
  strokeWidth?: string
  title?: string
}

export const UAGLogo: React.FC<IconProps> = () => (
  <svg
    height="100%"
    viewBox="0 0 600 180"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>UAG Logo</title>
    <g data-name="Layer_1">
      <path d="M390.28-.28H209.73v42.73h137.83v26.18H209.73v111.64h180.55V-.28Zm-42.73 137.91h-95.18v-26.18h95.18v26.18ZM600 68.64H488.36v42.72h68.91v26.27h-95.18V42.45H600V-.28H419.36v180.56H600V68.64zM180.55-.28h-42.72v137.91h-95.1V-.28H0v180.56h180.55V-.28z" />
    </g>
  </svg>
)

export const Account: React.FC<IconProps> = ({
  strokeColor = colors.offWhite,
  strokeWidth = "1px",
}) => (
  <svg
    fill="none"
    height="100%"
    stroke={strokeColor}
    strokeWidth={strokeWidth}
    viewBox="0 0 25 25"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Account Icon</title>
    <path
      clipRule="evenodd"
      d="M12.128 5.756a2.373 2.373 0 1 0 .002 4.746 2.373 2.373 0 0 0-.002-4.746zM8.256 8.13a3.873 3.873 0 1 1 7.746-.004 3.873 3.873 0 0 1-7.746.004zM4.452 19.489l1.6-.001a6.454 6.454 0 0 1 11.914-.006l1.6-.001a7.955 7.955 0 0 0-15.114.008z"
      fill={strokeColor}
      fillRule="evenodd"
    />
  </svg>
)

export const Add: React.FC<IconProps> = ({
  strokeColor = colors.black,
  strokeWidth = "1.5px",
}) => (
  <svg
    fill="none"
    height="100%"
    stroke={strokeColor}
    strokeMiterlimit="10"
    strokeWidth={strokeWidth}
    viewBox="0 0 33 33"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Add Icon</title>
    <path d="M16.2305 11.5566V22.2233" />
    <path d="M10.8975 16.8906H21.5641" />
  </svg>
)

export const Arrow: React.FC<IconProps> = ({
  strokeColor = colors.black,
  strokeWidth = "1.5px",
}) => (
  <svg
    fill="none"
    height="100%"
    stroke={strokeColor}
    strokeWidth={strokeWidth}
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Arrow Icon</title>
    <path
      d="M20 12H3M14 18l6-6-6-6"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
    />
  </svg>
)

export const Cameron: React.FC<IconProps> = ({
  strokeColor = colors.black,
}) => (
  <svg
    fill="none"
    height="100%"
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Cameron's Chevron Icon</title>
    <path d="M10.199 15.605l3.604-3.603-3.604-3.604" stroke={strokeColor} />
  </svg>
)

export const Cake: React.FC<IconProps> = ({ strokeColor = colors.black }) => (
  <svg
    height="100%"
    viewBox="0 0 448 512"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Cake Icon</title>
    <path
      d="M352 111.1c22.09 0 40-17.88 40-39.97S352 0 352 0s-40 49.91-40 72 17.9 39.1 40 39.1zm-128 0c22.09 0 40-17.88 40-39.97S224 0 224 0s-40 49.91-40 72 17.9 39.1 40 39.1zm159.1 112 .9-63.1c0-8.836-7.164-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64v-64c0-8.836-7.164-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64v-64c0-8.836-7.164-16-16-16H80c-8.84 0-16 7.2-16 16v63.97c-35.35 0-64 28.65-64 63.1v68.7c9.814 6.102 21.39 11.33 32 11.33 20.64 0 45.05-19.73 52.7-27.33 6.25-6.219 16.34-6.219 22.59 0 6.81 8.53 32.11 27.33 52.71 27.33s45.05-19.73 52.7-27.33c6.25-6.219 16.34-6.219 22.59 0 6.81 8.53 32.11 27.33 52.71 27.33s45.05-19.73 52.7-27.33c6.25-6.219 16.34-6.219 22.59 0 6.81 8.53 32.11 27.33 52.71 27.33 10.61 0 22.19-5.227 32-11.33V287.1c0-34.5-28.7-64-64.9-64zM352 373.3c-13.75 10.95-38.03 26.66-64 26.66s-50.25-15.7-64-26.66c-13.75 10.95-38.03 26.66-64 26.66s-50.25-15.7-64-26.66c-13.75 10.95-38.03 26.66-64 26.66-11.27 0-22.09-3.121-32-7.377v87.38C0 497.7 14.33 512 32 512h384c17.67 0 32-14.33 32-32v-87.38c-9.91 4.256-20.73 7.377-32 7.377-26-.897-50.2-15.697-64-26.697zM96 111.1c22.09 0 40-17.88 40-39.97S96 0 96 0 56 49.91 56 72s17.91 39.1 40 39.1z"
      stroke={strokeColor}
    />
  </svg>
)

export const Cart: React.FC<IconProps> = ({
  strokeColor = colors.black,
  strokeWidth = "1.5",
}) => (
  <svg
    fill="none"
    height="100%"
    viewBox="0 0 24 25"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Cart Icon</title>
    <path
      d="M2.34375 5.00391H4.0079C4.47418 5.00391 4.87858 5.32616 4.98267 5.78067L7.32039 15.9885C7.42448 16.443 7.82888 16.7653 8.29516 16.7653H18.8578"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
    />
    <path
      d="M5.5 8.75198H18.8243C19.4662 8.75198 19.9418 9.34811 19.7994 9.97397L19.159 12.7867C19.0554 13.2418 18.6507 13.5647 18.1839 13.5647H6.78569"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
    />
    <circle cx="7.53096" cy="19.6833" fill={strokeColor} r="1.0544" />
    <circle cx="17.6169" cy="19.6833" fill={strokeColor} r="1.0544" />
  </svg>
)

export const Check: React.FC<IconProps> = ({
  strokeColor = colors.black,
  strokeWidth = "1.5",
}) => (
  <svg
    fill="none"
    height="100%"
    stroke={strokeColor}
    strokeWidth={strokeWidth}
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Check Icon</title>
    <path
      d="M7.5 12L10.5 15L16.5 9"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
    />
  </svg>
)

export const Chevron: React.FC<IconProps> = ({
  strokeColor = colors.black,
  strokeWidth = "1.5",
}) => (
  <svg
    fill="none"
    height="100%"
    stroke={strokeColor}
    strokeWidth={strokeWidth}
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Chevron Icon</title>
    <path d="M10 16L14 12L10 8" />
  </svg>
)

export const CloseAlt: React.FC<IconProps> = ({
  strokeColor = colors.black,
  strokeWidth = "1.5",
}) => (
  <svg
    fill="none"
    height="100%"
    stroke={strokeColor}
    strokeWidth={strokeWidth}
    viewBox="0 0 12 12"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.666016 11.3334L11.3327 0.666748"
      stroke={strokeColor}
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M11.3327 11.3334L0.666016 0.666748"
      stroke={strokeColor}
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
  </svg>
)

export const Close: React.FC<IconProps> = ({
  strokeColor = colors.black,
  strokeWidth = "1.5",
}) => (
  <svg
    fill="none"
    height="100%"
    stroke={strokeColor}
    strokeMiterlimit="10"
    strokeWidth={strokeWidth}
    viewBox="0 0 40 40"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Close Icon</title>
    <path d="M13.332 26.6673L26.6654 13.334" />
    <path d="M26.6654 26.6673L13.332 13.334" />
  </svg>
)

export const CloseRound: React.FC<IconProps> = ({
  strokeColor = colors.offWhite,
}) => (
  <svg
    fill="none"
    height="100%"
    viewBox="0 0 57 57"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="#000" height="56" rx="28" width="56" x=".305" y=".541" />
    <path
      d="M21.639 35.209l13.333-13.334M34.972 35.209L21.639 21.875"
      stroke={strokeColor}
    />
  </svg>
)

export const Facebook: React.FC<IconProps> = ({
  strokeColor = colors.offWhite,
}) => (
  <svg
    fill="none"
    height="100%"
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Facebook Icon</title>
    <path
      d="M19.1158 4H4.88421C4.6497 4 4.4248 4.09316 4.25898 4.25898C4.09316 4.4248 4 4.6497 4 4.88421V19.1158C4 19.3503 4.09316 19.5752 4.25898 19.741C4.4248 19.9068 4.6497 20 4.88421 20H12.5474V13.8246H10.4561V11.3909H12.5361V9.61404C12.5361 7.54526 13.7965 6.41965 15.6407 6.41965C16.2672 6.42151 16.8931 6.45712 17.5158 6.52632V8.68491H16.2414C15.2393 8.68491 15.0456 9.1593 15.0456 9.85825V11.4021H17.4456L17.134 13.8246H15.0456V20H19.1158C19.3503 20 19.5752 19.9068 19.741 19.741C19.9068 19.5752 20 19.3503 20 19.1158V4.88421C20 4.6497 19.9068 4.4248 19.741 4.25898C19.5752 4.09316 19.3503 4 19.1158 4V4Z"
      fill={strokeColor}
    />
  </svg>
)

export const Filter: React.FC<IconProps> = ({ strokeColor = "#838588" }) => (
  <svg
    fill="none"
    height="100%"
    viewBox="0 0 20 20"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Filter Icon</title>
    <path
      d="M10 10.7895L14.8572 5.16536C14.9131 5.10057 14.8671 5 14.7815 5H5.21849C5.13288 5 5.08686 5.10057 5.14281 5.16536L10 10.7895ZM10 10.7895V15"
      stroke={strokeColor}
    />
  </svg>
)

export const Instagram: React.FC<IconProps> = ({
  strokeColor = colors.offWhite,
}) => (
  <svg
    fill="none"
    height="100%"
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Instagram Icon</title>
    <path
      clipRule="evenodd"
      d="M12.072 4c-2.193 0-2.467.01-3.328.049-.86.039-1.446.175-1.96.375-.53.206-.98.482-1.43.93a3.957 3.957 0 0 0-.93 1.43c-.2.514-.336 1.1-.375 1.96-.04.86-.049 1.135-.049 3.328 0 2.192.01 2.467.049 3.328.039.859.175 1.445.375 1.959.206.53.482.98.93 1.43.45.448.9.724 1.43.93.514.2 1.1.336 1.96.376.86.039 1.135.048 3.328.048 2.192 0 2.467-.01 3.328-.048.859-.04 1.445-.176 1.959-.376.53-.206.98-.482 1.43-.93.448-.45.724-.9.93-1.43.2-.514.336-1.1.376-1.96.039-.86.048-1.135.048-3.327 0-2.193-.01-2.467-.048-3.328-.04-.86-.176-1.446-.376-1.96a3.958 3.958 0 0 0-.93-1.43 3.956 3.956 0 0 0-1.43-.93c-.514-.2-1.1-.336-1.96-.375-.86-.04-1.135-.049-3.327-.049zm0 1.454c2.155 0 2.41.009 3.261.047.787.036 1.214.168 1.499.278a2.5 2.5 0 0 1 .928.604 2.5 2.5 0 0 1 .604.928c.11.285.242.712.278 1.499.039.851.047 1.106.047 3.262 0 2.155-.008 2.41-.047 3.261-.036.787-.168 1.214-.278 1.499a2.5 2.5 0 0 1-.604.928 2.5 2.5 0 0 1-.928.604c-.285.11-.712.242-1.499.278-.85.039-1.106.047-3.261.047-2.156 0-2.411-.008-3.262-.047-.787-.036-1.214-.168-1.499-.278a2.5 2.5 0 0 1-.928-.604 2.5 2.5 0 0 1-.604-.928c-.11-.285-.242-.712-.278-1.499-.038-.85-.047-1.106-.047-3.261 0-2.156.009-2.41.047-3.262.036-.787.168-1.214.278-1.499a2.5 2.5 0 0 1 .604-.928 2.5 2.5 0 0 1 .928-.604c.285-.11.712-.242 1.499-.278.851-.038 1.106-.047 3.262-.047z"
      fill={strokeColor}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M12.07 14.761a2.69 2.69 0 1 1 0-5.38 2.69 2.69 0 0 1 0 5.38zm0-6.835a4.145 4.145 0 1 0 0 8.29 4.145 4.145 0 0 0 0-8.29zM17.347 7.764a.969.969 0 1 1-1.937 0 .969.969 0 0 1 1.937 0"
      fill={strokeColor}
      fillRule="evenodd"
    />
  </svg>
)

export const Loading: React.FC<IconProps> = () => (
  <svg
    height="100%"
    viewBox="0 0 200 200"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Loading Icon</title>
    <radialGradient
      cx=".66"
      cy=".3125"
      fx=".66"
      fy=".3125"
      gradientTransform="scale(1.5)"
      id="a12"
    >
      <stop offset="0" stopColor="#F26722"></stop>
      <stop offset=".3" stopColor="#F26722" stopOpacity=".9"></stop>
      <stop offset=".6" stopColor="#F26722" stopOpacity=".6"></stop>
      <stop offset=".8" stopColor="#F26722" stopOpacity=".3"></stop>
      <stop offset="1" stopColor="#F26722" stopOpacity="0"></stop>
    </radialGradient>
    <circle
      cx="100"
      cy="100"
      fill="none"
      r="70"
      stroke="url(#a12)"
      strokeDasharray="200 1000"
      strokeDashoffset="0"
      strokeLinecap="round"
      strokeWidth="15"
      transform-origin="center"
    >
      <animateTransform
        attributeName="transform"
        calcMode="spline"
        dur="2"
        keySplines="0 0 1 1"
        keyTimes="0;1"
        repeatCount="indefinite"
        type="rotate"
        values="360;0"
      ></animateTransform>
    </circle>
    <circle
      cx="100"
      cy="100"
      fill="none"
      opacity=".2"
      r="70"
      stroke="#F26722"
      strokeLinecap="round"
      strokeWidth="15"
      transform-origin="center"
    ></circle>
  </svg>
)

export const Menu: React.FC<IconProps> = ({
  strokeColor = colors.black,
  strokeWidth = "1.5",
}) => (
  <svg
    fill="none"
    height="100%"
    stroke={strokeColor}
    strokeWidth={strokeWidth}
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Menu Icon</title>
    <path d="M4 9H20.9231M4 15H14.2345" />
  </svg>
)

export const Minus: React.FC<IconProps> = ({
  strokeColor = colors.black,
  strokeWidth = "2",
}) => (
  <svg
    fill="none"
    height="100%"
    stroke={strokeColor}
    strokeMiterlimit="10"
    strokeWidth={strokeWidth}
    viewBox="0 0 33 33"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Remove Icon</title>
    <path d="M10.545 16.8906h12.011" />
  </svg>
)

export const Pencil: React.FC<IconProps> = ({
  strokeColor = colors.black,
  strokeWidth = "0",
}) => (
  <svg
    fill="none"
    height="100%"
    stroke={strokeColor}
    strokeWidth={strokeWidth}
    viewBox="0 0 21 20"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Pencil Icon</title>
    <path
      d="M15.404 5.83l-.935-.934a1 1 0 00-1.414 0l-.7.7a.5.5 0 000 .707l1.641 1.642a.5.5 0 00.707 0l.7-.7a1 1 0 000-1.414zM11.495 7.157a.5.5 0 00-.707 0l-5.955 5.955a2 2 0 00-.57 1.174l-.243 1.998 1.998-.243a2 2 0 001.172-.571l5.955-5.956a.5.5 0 000-.707l-1.65-1.65z"
      fill={strokeColor}
    />
  </svg>
)

export const Search: React.FC<IconProps> = ({
  strokeColor = colors.black,
  strokeWidth = "1.5",
}) => (
  <svg
    fill="none"
    height="100%"
    stroke={strokeColor}
    strokeWidth={strokeWidth}
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Search Icon</title>
    <circle cx="11.5" cy="11.5" r="5.75" />
    <path d="M16 16L19 19" />
  </svg>
)

export const Shipping: React.FC<IconProps> = ({
  strokeColor = colors.offBlack,
}) => (
  <svg
    fill="none"
    height="100%"
    viewBox="0 0 20 16"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M13.619.68H.05V12.3h18.047a1.75 1.75 0 001.75-1.75V8.644a2.75 2.75 0 00-.684-1.815l-1.545-1.76A3.75 3.75 0 0014.8 3.794h-1.182V.68zm0 10.121V5.294H14.8a2.25 2.25 0 011.69.765l1.546 1.76c.2.228.31.521.31.825v1.907a.25.25 0 01-.25.25H13.62zm-1.5-8.621v8.62H1.55V2.18h10.568zm-7.94 13.715a1.27 1.27 0 100-2.54 1.27 1.27 0 000 2.54zm12.888-1.27a1.27 1.27 0 11-2.54 0 1.27 1.27 0 012.54 0zM14.359 6.28v1.318c0 .138.112.25.25.25h1.711a.25.25 0 00.194-.409l-.653-.8a1.25 1.25 0 00-.969-.46h-.433a.1.1 0 00-.1.1z"
      fill={strokeColor}
      fillRule="evenodd"
    />
  </svg>
)

export const Shopping: React.FC<IconProps> = ({
  strokeColor = colors.black,
}) => (
  <svg
    height="100%"
    viewBox="0 0 448 512"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Shopping Icon</title>
    <path
      d="M112 112C112 50.14 162.1 0 224 0s112 50.14 112 112v48h64c26.5 0 48 21.5 48 48v208c0 53-43 96-96 96H96c-53.02 0-96-43-96-96V208c0-26.5 21.49-48 48-48h64v-48zm48 48h128v-48c0-35.35-28.7-64-64-64s-64 28.65-64 64v48zm-24 96c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24zm176-48c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24z"
      stroke={strokeColor}
    />
  </svg>
)

export const Star: React.FC<IconProps> = ({ strokeColor = colors.black }) => (
  <svg
    fill="none"
    height="100%"
    viewBox="0 0 18 18"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Star Icon</title>
    <path
      d="M8.81673 0L11.0451 5.74959L17.2019 6.09221L12.4224 9.98827L13.9991 15.9496L8.81673 12.6079L3.63439 15.9496L5.21109 9.98827L0.431521 6.09221L6.58832 5.74959L8.81673 0Z"
      fill={strokeColor}
    />
  </svg>
)

export const Trash: React.FC<IconProps> = ({
  strokeColor = colors.mediumGray,
  strokeWidth = "1.5",
}) => (
  <svg
    fill="none"
    height="100%"
    stroke={strokeColor}
    strokeLinecap="round"
    strokeMiterlimit={"10"}
    strokeWidth={strokeWidth}
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Trash Icon</title>
    <path d="M6.389 10.5l.802 7.22A2 2 0 009.18 19.5h5.42a2 2 0 001.987-1.78l.803-7.22M6.389 6.334H17.61M12 4.5v1.833" />
  </svg>
)

export const Twitter: React.FC<IconProps> = ({
  strokeColor = colors.offWhite,
}) => (
  <svg
    fill="none"
    height="100%"
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Twitter Icon</title>
    <path
      d="M21 6.846a7.555 7.555 0 0 1-2.128.57 3.644 3.644 0 0 0 1.63-2 7.537 7.537 0 0 1-2.355.877 3.747 3.747 0 0 0-2.706-1.142c-2.048 0-3.708 1.619-3.708 3.615 0 .283.033.56.096.824a10.617 10.617 0 0 1-7.641-3.777 3.528 3.528 0 0 0-.502 1.817 3.59 3.59 0 0 0 1.65 3.009 3.762 3.762 0 0 1-1.68-.452v.045c0 1.752 1.278 3.213 2.974 3.545a3.804 3.804 0 0 1-1.675.062c.472 1.436 1.841 2.481 3.464 2.51a7.56 7.56 0 0 1-4.605 1.548c-.3 0-.594-.017-.884-.05a10.689 10.689 0 0 0 5.683 1.623c6.82 0 10.549-5.508 10.549-10.285 0-.157-.004-.312-.011-.468A7.426 7.426 0 0 0 21 6.847z"
      fill={strokeColor}
    />
  </svg>
)

export const Upload: React.FC<IconProps> = ({ strokeColor = colors.black }) => (
  <svg
    fill="none"
    height="100%"
    viewBox="0 0 20 20"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.468 18.242H2.532h14.936ZM10 13.886V2.266"
      stroke={strokeColor}
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M5.898 5.683 10 1.582 14.1 5.683"
      stroke={strokeColor}
      strokeWidth="1.5"
    />
  </svg>
)

export const Youtube: React.FC<IconProps> = ({
  strokeColor = colors.offWhite,
}) => (
  <svg
    fill="none"
    height="100%"
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Youtube Icon</title>
    <path
      d="M20.748 8.251c0-1.406-1.122-2.695-2.468-2.812a45.109 45.109 0 0 0-12.56 0 2.65 2.65 0 0 0-1.76.902 2.883 2.883 0 0 0-.708 1.91 27.975 27.975 0 0 0 0 7.498c0 1.406 1.122 2.694 2.468 2.812 4.15.585 8.41.585 12.56 0 1.346-.235 2.355-1.406 2.468-2.812a27.98 27.98 0 0 0 0-7.498zM9.757 15.515v-7.03L15.364 12l-5.607 3.515z"
      fill={strokeColor}
    />
  </svg>
)
